import {
  addedStatusList,
  CrudRow,
  RowCrudStatus,
  originalDeletedStatusList,
  originalUpdatedStatusList,
  FileCRUDType,
  GridChangeSet,
} from "./types";
import { removeAttrs } from "./services/crudServices";
import { UploadedFile } from "../../api/graphql";
import { MaskConfigType } from "./controls/InputStringMask";

export function fieldByLang(baseFieldName: string, language: string) {
  return `${baseFieldName}_${language}`;
}

export const getFixedChangeSet = (
  changes: GridChangeSet,
  rows: CrudRow[]
): GridChangeSet => {
  if (changes.deleted && changes.deleted.length > 0) {
    const id: string = changes.deleted[0].toString();
    const row = Object.entries(rows)
      .filter(([_key, value]) => value.id === id)
      .map((x) => {
        return Object.fromEntries(Object.entries(x));
      });
    const rowId = row[0]["0"].toString();
    return { deleted: [rowId] };
  }
  return changes;
};

export const getNewFilesToUpload = (rows: CrudRow[]) => {
  return Object.values(rows)
    .filter((x) => addedStatusList.includes(x.__status__))
    .map((x) => {
      return removeAttrs({ ...x }, ["__status__", "id"]);
    });
};

export const singleSubEntityUpdateVariable = (
  rows: { __status__: RowCrudStatus }[]
) => {
  return Object.values(rows)
    .filter((x) => addedStatusList.includes(x.__status__))
    .map((x) => {
      return Object.fromEntries(
        Object.entries(x).filter(
          ([key]) => key !== "id" && !key.startsWith("__")
        )
      );
    })
    .shift();
};

export const subEntityUpdateVariable = (
  rows: { __status__: RowCrudStatus }[]
) => {
  return {
    create: Object.values(rows)
      .filter((x) => addedStatusList.includes(x.__status__))
      .map((x) => {
        return Object.fromEntries(
          Object.entries(x).filter(
            ([key]) => key !== "id" && !key.startsWith("__")
          )
        );
      }),
    update: Object.values(rows)
      .filter((x) => originalUpdatedStatusList.includes(x.__status__))
      .map((x) => {
        return Object.fromEntries(
          Object.entries(x).filter(
            ([key]) => !["displayId"].includes(key) && !key.startsWith("__")
          )
          // .map((row) => {
          //     this.eventsUpdateStore.loadValuesFromRow(row);
          //     return {
          //       ...this.eventsUpdateStore.buildVariables(),
          //       id: row.__instance.id,
          //       version_: row.__instance.version_,
          //     };
          // }),
        );
      }),
    remove: Object.values(rows)
      .filter((x) => originalDeletedStatusList.includes(x.__status__))
      .map((x) => {
        return Object.fromEntries(
          Object.entries(x).filter(([key]) => key === "id")
        );
      })
      .map((x) => x.id),
  };
};

export const toUpdateSingleFile = (obj: {
  create: any;
  update: any;
  remove: string[];
}): UploadedFile | null => {
  if (obj.create && obj.create.length > 0) {
    return obj.create[0];
  } else if (obj.update && obj.update.length > 0) {
    return obj.update[0];
  } else if (obj.remove && obj.remove.length > 0) {
    return {
      filename: "remove",
      mimetype: "remove",
      size: 0,
      ticket: "remove",
    };
  }
  return null;
};

export const getFileVariableValue = (files: FileCRUDType[]) => {
  let photoValue: any = files.filter((x) =>
    addedStatusList.includes(x.__status__)
  );
  if (photoValue.length === 0) {
    photoValue = files.filter((x) =>
      originalDeletedStatusList.includes(x.__status__)
    );
    if (photoValue.length > 0) {
      return null;
    }
  } else {
    return {
      encoding: photoValue[0].encoding,
      filename: photoValue[0].name,
      mimetype: photoValue[0].mimetype,
      size: photoValue[0].size,
      ticket: photoValue[0].ticket,
    };
  }
  return undefined;
};

const fakeFile = {
  encoding: "",
  filename: "",
  mimetype: "",
  size: 0,
  ticket: "",
};

export const getNotNullFileVariableValue = (files: FileCRUDType[]) => {
  const file = getFileVariableValue(files);
  if (!file) {
    return fakeFile;
  }
  return file;
};

export const getNewCRUDRows = (
  _changes: GridChangeSet,
  _crudRows: CrudRow[],
  _newCounter: number
): CrudRow[] => {
  return [];
  // const newCrudRows = { ...crudRows };
  // if (changes.added) {
  //   changes.added.forEach((x) => {
  //     const id = `__${newCounter}`;
  //     newCrudRows[id] = { ...x, id, __status__: "added" };
  //   });
  // }
  //
  // if (changes.changed) {
  //   Object.entries(changes.changed).forEach(([id, x]) => {
  //     if (x) {
  //       let areEquals = true;
  //       Object.entries(x).forEach((item) => {
  //         if (newCrudRows[id][item[0]] !== item[1]) {
  //           areEquals = false;
  //         }
  //       });
  //       if (!areEquals) {
  //         if (newCrudRows[id].__status__ === "original") {
  //           newCrudRows[id] = {
  //             ...newCrudRows[id],
  //             ...x,
  //             __status__: "original-updated",
  //           };
  //         } else if (newCrudRows[id].__status__ === "original-deleted") {
  //           newCrudRows[id] = {
  //             ...newCrudRows[id],
  //             ...x,
  //             __status__: "original-updated-deleted",
  //           };
  //         } else {
  //           newCrudRows[id] = { ...newCrudRows[id], ...x };
  //         }
  //       }
  //     }
  //   });
  // }
  // if (changes.deleted) {
  //   changes.deleted.forEach((x) => {
  //     if (newCrudRows[x].__status__ === "added") {
  //       delete newCrudRows[x];
  //     } else {
  //       if (newCrudRows[x].__status__ === "original") {
  //         newCrudRows[x].__status__ = "original-deleted";
  //       } else if (newCrudRows[x].__status__ === "original-updated") {
  //         newCrudRows[x].__status__ = "original-updated-deleted";
  //       }
  //     }
  //   });
  // }
  // return newCrudRows;
};

export const validateMask = (
  value: string,
  maskConfig: MaskConfigType
): boolean => {
  // // Usando patrones por defecto
  //   console.log(validateMask('000004/5', { mask: '999999/9' })); // true
  //   console.log(validateMask('45', { mask: '999999/9' })); // false
  //
  // // Usando formatChars personalizados
  //   const configConFormatChars = {
  //     mask: 'UU-99',
  //     formatChars: {
  //       'U': '[A-Z]',      // Solo letras mayúsculas
  //       '9': '[0-9]'       // Números
  //     }
  //   };
  //   console.log(validateMask('AB-12', configConFormatChars)); // true
  //   console.log(validateMask('ab-12', configConFormatChars)); // false (minúsculas no permitidas)
  //   console.log(validateMask('A1-12', configConFormatChars)); // false (número donde debería ir letra)
  //
  // // Otro ejemplo con formatChars personalizados
  //   const configDNI = {
  //     mask: '99.999.999-L',
  //     formatChars: {
  //       '9': '[0-9]',
  //       'L': '[A-HJ-NP-TV-Z]'  // Letras válidas para DNI español (excluyendo I,Ñ,O,U)
  //     }
  //   };
  //   console.log(validateMask('12.345.678-Z', configDNI)); // true
  //   console.log(validateMask('12.345.678-I', configDNI)); // false (I no es válida)

  const { mask, formatChars } = maskConfig;

  // Si el valor está vacío, consideramos que no cumple la máscara
  if (!value) return false;

  // Si las longitudes no coinciden, no cumple la máscara
  if (value.length !== mask.length) return false;

  // Patrones por defecto si no se especifican formatChars
  const defaultPatterns: { [key: string]: string } = {
    "9": "[0-9]",
    a: "[a-zA-Z]",
    "*": "[a-zA-Z0-9]",
  };

  // Combinamos los patrones por defecto con los formatChars personalizados
  const patterns = { ...defaultPatterns, ...formatChars };

  // Iteramos sobre cada carácter del valor y la máscara
  for (let i = 0; i < mask.length; i++) {
    const maskChar = mask[i];
    const valueChar = value[i];

    // Si el carácter de la máscara tiene un patrón definido
    if (patterns[maskChar]) {
      const pattern = new RegExp(`^${patterns[maskChar]}$`);
      if (!pattern.test(valueChar)) {
        return false;
      }
    } else {
      // Si el carácter de la máscara es literal (como '/'), debe coincidir exactamente
      if (maskChar !== valueChar) {
        return false;
      }
    }
  }

  return true;
};
